import type { EnvironmentProviders, Provider } from '@angular/core';
import { ErrorHandler, Injector, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { config as rxjsConfig } from 'rxjs';

import { LariErrorHandler } from './lari-error-handler';

/** `onUnhandledError` is what an `error`-callback-less `.subscribe()` reaches — 655 of them, none editable one by one. */
const forwardRxjsErrors = () => {
  const injector = inject(Injector);
  // Resolved per error, not here: building the handler pulls in TranslateService,
  // whose own initializer has not run yet.
  rxjsConfig.onUnhandledError = (error: unknown) => {
    injector.get(ErrorHandler).handleError(error);
  };
};

/**
 * Every path a failure can take to `ErrorHandler`: Angular's own listeners, rxjs' unhandled-error
 * hook, and the handler itself. Registered first, so its initializer runs before any other's.
 */
export const provideErrorBoundary = (): (Provider | EnvironmentProviders)[] => [
  provideBrowserGlobalErrorListeners(),
  { provide: ErrorHandler, useClass: LariErrorHandler },
  provideAppInitializer(forwardRxjsErrors),
];
